import { Area } from "./area";
import { BusinessType } from "./business-type";
import { Product } from "./product";
import { Shop } from "./shop";

export enum BannerType {
  Top = "TOP", //Đầu trang home
  Hot = "HOT", //Hôm nay có gì hot
  BusinessType = "BUSINESS_TYPE", //Dành cho banner thuộc business
  Footer = "FOOTER", //Cuối trang home
}

export const BannerTypeTrans = {
  [BannerType.Top]: "Đầu trang chủ",
  [BannerType.Hot]: "Hôm nay có gì hot",
  [BannerType.Footer]: "Cuối trang chủ",
  [BannerType.BusinessType]: "Dành cho banner thuộc business",
};

export enum BannerContentType {
  Content = "CONTENT",
  Link = "LINK",
  Shop = "SHOP",
  Product = "PRODUCT",
}

export const BannerContentTypeTrans = {
  [BannerContentType.Content]: "Nội dung",
  [BannerContentType.Link]: "Đường link",
  [BannerContentType.Product]: "Sản phẩm",
  [BannerContentType.Shop]: "Doanh nghiệp",
};

export interface Banner {
  id: number;
  createdAt: number;
  updatedAt: number;
  isDeleted: boolean;
  title: string;
  link: string;
  type: BannerType;
  image: string;
  shop: Shop;
  isVisible: boolean;
  content: string;
  area: Area;
  businessType: BusinessType;
  product: Product;
}
